import {createInertiaApp} from '@inertiajs/react'
import {createRoot, hydrateRoot} from 'react-dom/client'
import React, {ReactNode} from "react";
import Layout from "@/Components/Layout";
import './app.scss';
import './app.mobile.scss';
import MyApp from '@/Components/App';
import './i18n';

document.addEventListener('inertia:error', (e) => {
    console.error('inertia:error', e)
    e.preventDefault()
})

document.addEventListener('inertia:invalid', ev => {
    // 返回html时直接跳转
    if (ev.detail.response.headers["content-type"].includes("text/html")) {
        ev.preventDefault()
        window.location.href = ev.detail.response.config.url as string
    }
})

document.addEventListener('inertia:before', (e) => {
    history.scrollRestoration = 'auto'
    sessionStorage.setItem(location.href + 'scrollY', window.scrollY.toString())
})

window.addEventListener('popstate', (e) => {
    if (sessionStorage.getItem(location.href + 'scrollY') !== null) {
        setTimeout(() => {
            window.scroll({
                top: Number(sessionStorage.getItem(location.href + 'scrollY')),
            })
        }, 50)
    }
})

createInertiaApp({
progress: {
        color: 'var(--theme-primary)',
      },
    resolve: async name => {
        const pages = import.meta.glob('./Pages/**/*.tsx')
        const page = await pages[`./Pages/${name}.tsx`]()
        //@ts-ignore
        page.default.layout = page.default.layout || ((page: ReactNode) => <Layout children={page}/>)

        return page
    },
    setup({el, App, props}) {
        const app = <MyApp isMobileView={props.initialPage.props.isMobileView as boolean}>
            <App {...props} />
        </MyApp>

        if (import.meta.env.DEV) {
            createRoot(el).render(app)
        } else {
            // ssr 渲染请使用以下代码
            hydrateRoot(el, app)
        }
    },
})